// Centralized API base URL for the application
export const API_BASE =
"https://hrm.sportstech.team/api";
// "https://insoluble-unseparately-delena.ngrok-free.dev/api/login/";